import { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "..";
import { Button, CustomLink, Layout, PageTitle, Row, SelectService } from "../components";
import config from "../config";
import $api from "../http";
import { Service } from "../types";
import logo from "../assets/logo.svg";
import styled from "styled-components";
import { observer } from "mobx-react";

const SelectList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 16px;
  background: #f5f5f8;
  max-height: 260px;
  width: 100%;
  overflow-y: auto;
  gap: 20px;
  h1 {
    font-weight: 500;
    font-size: 20px;
    margin: 0;
    text-align: center;
    margin-bottom: 15px;
  }
  @media (max-width: 500px) {
    max-width: calc(100% - 0px);
    background: white;
    padding: 0;
    border-radius: 0px;
    max-height: 310px;

    h1 {
      display: none;
    }
  }
`;

const ServiceMaster: FC<{ title: string }> = observer(({ title }) => {
  const { store } = useContext(Context);
  const navigate = useNavigate();

  const [services, setServices] = useState<Service[]>([]);
  const [selectedServices, setSelectedServices] = useState<Service[]>([]);

  const [products, setProducts] = useState<Service[]>([]);
  const [selectedProducts, setSelectedProducts] = useState<Service[]>([]);

  useEffect(() => {
    if (!store.isAuth) return navigate("/");
  }, [store, navigate]);

  useEffect(() => {
    if (!store.products) {
      $api.get(`${config.API}/product/all`).then(({ data }) => {
        store.setProducts(data.data);
        setProducts(data.data);
      });
    } else {
      setProducts(store.products);
    }
  }, [store]);

  useEffect(() => {
    if (!store.services) {
      $api.get(`${config.API}/service/all`).then(({ data }) => {
        store.setServices(data.data);
        setServices(data.data);
      });
    } else {
      setServices(store.services);
    }
  }, [store]);

  const sendData = () => {
    if (selectedProducts.length <= 0 && selectedServices.length <= 0) return alert("Выберите услугу или товар");
    store.setSelectedProducts(selectedProducts);
    store.setSelectedServices(selectedServices);
    navigate("/default/phone");
  };

  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={128} height={128} />
      <CustomLink to={"/default/master"}>{"<-"} Выбор мастера</CustomLink>
      <PageTitle>Выбор услуг</PageTitle>
      <Row style={{ gap: 30, width: "100%" }}>
        {products.length > 0 && (
          <SelectList>
            <>
              <h1>Товары</h1>
              {products &&
                products.map((e: Service) => {
                  return (
                    <SelectService
                      key={e._id}
                      name={e.name}
                      price={e.price}
                      sale={e.sale}
                      onClick={(b: boolean) => {
                        setSelectedProducts((prev: Service[]) => (b ? [...prev, e] : prev.filter((c) => c !== e)));
                      }}
                    />
                  );
                })}
            </>
          </SelectList>
        )}
        {services.length > 0 && (
          <SelectList>
            <>
              <h1>Услуги</h1>
              {services &&
                services.map(
                  (e: Service) =>
                    e && (
                      <SelectService
                        key={e._id}
                        name={e.name}
                        price={e.price}
                        sale={e.sale}
                        onClick={(b: boolean) => {
                          setSelectedServices((prev: Service[]) => (b ? [...prev, e] : prev.filter((c) => c !== e)));
                        }}
                      />
                    )
                )}
            </>
          </SelectList>
        )}
      </Row>
      <Row style={{ width: "100%" }}>
        <Button onClick={sendData} style={{ width: "100%" }}>
          Продолжить
        </Button>
      </Row>
    </Layout>
  );
});

export default ServiceMaster;
